import React from 'react';
import PropTypes from 'prop-types';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import EnabledFilter from 'components/form/filters/EnabledFilter';
import UsesDiscountCodesFilter from 'components/form/filters/UsesDiscountCodesFilter';
import TitleFilter from 'components/form/filters/TitleFilter';

const DiscountsListFilters = (props) => {
    const filters = {
        basic: {
            title: {
                component: TitleFilter,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            is_enabled: {
                component: EnabledFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
        advanced: {
            uses_discount_codes: {
                component: UsesDiscountCodesFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
    };

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

DiscountsListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default DiscountsListFilters;



// WEBPACK FOOTER //
// ./src/pages/discounts/list/DiscountsListFilters.js